module.exports = __webpack_public_path__ + "static/media/B0.2b57e84a.svg";